import { render, staticRenderFns } from "./select-one-radio.vue?vue&type=template&id=38660480"
import script from "./select-one-radio.vue?vue&type=script&lang=js"
export * from "./select-one-radio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports